import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// Grouping from context.user; zero-count entries are intentional for empty UI states.
type Arguments = Record<string, never>;

const schemaChatUnreadEntry = z.object({
    chatId: schemaId,
    customerIdentity: z.string(),
    unreadCount: z.number().int().nonnegative(),
});

export const schemaChatResolver_GetInboxUnreadSummary = z.object({
    byLoanRequest: z.array(
        z.object({
            chats: z.array(schemaChatUnreadEntry),
            loanRequestId: schemaId,
        }),
    ),
    // Pid-matched (DL: + orphan) partner chats not already grouped under a visible loan request. Admins: all.
    partner: z.array(schemaChatUnreadEntry),
    // division-scoped, TL/DL visibility only — MUST be `[]` (never omitted) for an `adviser` role.
    unlinked: z.array(schemaChatUnreadEntry.extend({ phoneNumberId: z.string() })),
});

export type SchemaChatResolver_GetInboxUnreadSummary = z.infer<typeof schemaChatResolver_GetInboxUnreadSummary>;

export type ChatResolver_GetInboxUnreadSummary = Resolver<Arguments, SchemaChatResolver_GetInboxUnreadSummary>;
